<template>
	<div>
		<div class="row">
			<div class="col-lg-12 mb-4">
				<div class="card mb-4">
					<div
						class="card-header py-3 bg-tecq d-flex justify-content-between align-items-center flex-wrap gap-2"
					>
						<h6 class="m-0 font-weight-bold text-white">Auto Approval Codes Search</h6>
						<a
							href="/authcodes/export"
							class="btn btn-sm btn-light fw-semibold"
							download
							title="Download all auto-approval codes as CSV (opens in Excel)"
						>
							<i class="fas fa-file-excel me-1"></i> Export to Excel
						</a>
					</div>
					<div class="card-body">
						<div id="myTabContent" class="tab-content">
							<div
								id="singlcheck"
								role="tabpanel"
								aria-labelledby="home-tab"
								class="tab-pane active"
							>
								<label for="search_term" class="form-label"
									>Enter CPT Code or Procedure Description</label
								>
								<input
									class="form-control form-control-lg"
									id="search_term"
									type="text"
									name="search_term"
									placeholder="e.g. 99213 or Outpatient Visit"
									v-model="singlecheck.search_term"
									@input="onSearchInput"
									autocomplete="off"
								/>
								<div
									v-if="noResults"
									class="alert alert-warning py-2 mt-2 mb-0 text-center small"
								>
									No results found for
									<strong>"{{ singlecheck.search_term.trim() }}"</strong>.
									This code may not be in our Auto Approval List.
								</div>
								<div
									class="text-danger fw-semibold mt-3 mb-1 small text-center"
								>
									PLEASE NOTE: THIS EXCLUDES ALL MEMORIAL HERMANN HEALTHCARE SYSTEM
									PROVIDERS. PLEASE GENERATE PRIOR AUTHORIZATION.
								</div>
							</div>
						</div>
						<Loader v-show="showLoading" />
					</div>
				</div>
			</div>
		</div>

		<AuthCodesResult
			:claimresults="claimsResults"
			v-show="showResults && claimsResults.length > 0"
			ref="claimcheckresults"
		/>
	</div>
</template>

<script>
	import axios from "axios";
	import Loader from "./LoaderHelper.vue";
	import AuthCodesResult from "./AuthCodesResult.vue";

	export default {
		name: "ClaimCheckerR",
		components: { Loader, AuthCodesResult },
		data() {
			return {
				showLoading: false,
				claimsResults: [],
				showResults: false,
				singlecheck: {
					member_id: "",
					dos: "",
					search_term: "",
				},
				singleclaimcheck: {
					claim_id: "",
				},
				_searchTimer: null,
				_currentSearchToken: null,
				hasSearched: false,
			};
		},
		computed: {
			noResults() {
				const q = (this.singlecheck.search_term || "").trim();
				return (
					q.length >= 2 &&
					this.hasSearched &&
					!this.showLoading &&
					this.claimsResults.length === 0
				);
			},
		},
		methods: {
			onSearchInput() {
				if (this._searchTimer) clearTimeout(this._searchTimer);
				this._searchTimer = setTimeout(() => this.runSearch(), 400);
			},
			runSearch() {
				const q = (this.singlecheck.search_term || "").trim();
				if (q.length < 2) {
					this.claimsResults = [];
					this.showResults = false;
					this.hasSearched = false;
					return;
				}
				const token = Symbol();
				this._currentSearchToken = token;
				this.showLoading = true;
				axios
					.get("/authcodes/checkresult", { params: { search_term: q } })
					.then((response) => {
						// Ignore stale responses (user typed something newer)
						if (this._currentSearchToken !== token) return;
						this.claimsResults = Array.isArray(response.data) ? response.data : [];
						this.showResults = true;
						this.hasSearched = true;
					})
					.catch((error) => {
						if (this._currentSearchToken !== token) return;
						console.error(error);
						this.claimsResults = [];
						this.showResults = false;
						this.hasSearched = true;
					})
					.finally(() => {
						if (this._currentSearchToken === token) this.showLoading = false;
					});
			},

			// Kept for backward compatibility with any external caller
			checkSingle() {
				this.runSearch();
			},

			checkSingleClaim() {
				if (this.singleclaimcheck.claim_id === "") {
					alert("Please Enter a Claim ID!");
					return;
				}

				this.claimsResults = [];
				this.showLoading = true;

				axios
					.get("/claims/checkresult", {
						params: { claim_id: this.singleclaimcheck.claim_id },
					})
					.then((response) => {
						if (!response.data.hasOwnProperty("error")) {
							this.claimsResults = response.data;
						} else {
							alert(response.data.error);
						}
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						this.showLoading = false;
					});
			},
		},
		created() {
			axios.interceptors.request.use(
				(config) => {
					this.showLoading = true;
					return config;
				},
				(error) => {
					this.showLoading = false;
					return Promise.reject(error);
				}
			);

			axios.interceptors.response.use(
				(response) => {
					this.showLoading = false;
					return response;
				},
				(error) => {
					this.showLoading = false;
					return Promise.reject(error);
				}
			);
		},
	};
</script>
<style>
	.bg-tecq {
		background: #343f52;
	}
	.btn-tecq,
	.btn-tecq:hover {
		background: #607d8b;
		color: #fff;
	}
</style>
